<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>AR辅助敷设与装配系统</h1>
        </div>
        <div class="video">
          <div class="">
            <video src="../assets/project3.mp4" controls muted playsinline>
            </video>
          </div>
        </div>
        <div class="abstract">
          飞机线缆数量庞大，布局错综复杂，目前主要采用人工阅读图纸并进行敷设的方法，存在错误率高且难以校验、新手培训时间长、学习成本较大的问题。
          <br /><br />
          本项目为国内知名航空工业集团设计和开发基于增强现实的辅助系统，减轻操作人员敷设复杂线缆的学习负担与操作成本。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_1.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_4.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_5.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_3.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_6.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project3Zh",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
video {
  width: 100%;
}
.video {
  margin-top: 100px;
}
.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 4px;
  color: #333333;
}
</style>